import { Link } from 'gatsby'
import React from 'react'

const Footer = props => (
  <footer id="footer">
    {/*
    <section>
      <h2>Aliquam sed mauris</h2>
      <p>
        Sed lorem ipsum dolor sit amet et nullam consequat feugiat consequat
        magna adipiscing tempus etiam dolore veroeros. eget dapibus mauris. Cras
        aliquet, nisl ut viverra sollicitudin, ligula erat egestas velit, vitae
        tincidunt odio.
      </p>
      <ul className="actions">
        <li>
          <Link to="/generic" className="button">
            Learn More
          </Link>
        </li>
      </ul>
    </section>*/}
    
    <section>
      <h2>Contact</h2>
      <dl className="alt">
        <dt>Address</dt>
        <dd>No. 1, Sec. 4, Roosevelt Road, Taipei, 10617 Taiwan(R.O.C)</dd>
        {/*
        <dt>Phone</dt>
        <dd>(000) 000-0000 x 0000</dd>*/}
        <dt>Email</dt>
        <dd>
          <a>byronhsu1230@gmail.com</a>
        </dd>
        <dt>Problem Design</dt>
        <dd>
            <a href="https://github.com/shenperson">shenperson</a> <a href="https://github.com/tzyLee">tzyLee</a>
        </dd>
        <dt>Web development</dt>
        <dd>
            <a href="https://github.com/ByronHsu">ByronHsu</a> 
        </dd>
      </dl>
      {/*
      <ul className="icons">
        <li>
          <a
            href="https://twitter.com/huntaroSan"
            className="icon fa-twitter alt"
          >
            <span className="label">Twitter</span>
          </a>
        </li>
        <li>
          <a href="https://codebushi.com" className="icon fa-facebook alt">
            <span className="label">Facebook</span>
          </a>
        </li>
        <li>
          <a href="https://codebushi.com" className="icon fa-instagram alt">
            <span className="label">Instagram</span>
          </a>
        </li>
        <li>
          <a
            href="https://github.com/codebushi/gatsby-starter-stellar"
            className="icon fa-github alt"
          >
            <span className="label">GitHub</span>
          </a>
        </li>
        <li>
          <a href="https://codebushi.com" className="icon fa-dribbble alt">
            <span className="label">Dribbble</span>
          </a>
        </li>
      </ul>*/}
    </section>
    <p className="copyright">
      &copy; Untitled. Design: <a href="https://html5up.net">HTML5 UP</a>.
    </p>
  </footer>
)

export default Footer
